import Form from "./Form";

export default function Login() {
  return (
    <main>
      <Form
        title="Log in"
        formType="Log in"
        path="signup"
        linkText="No account? Sign up"
      />
    </main>
  );
}
